import React from 'react';

const FlowAction = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.0002 3.47295H20.8502C20.6102 3.47295 20.4302 3.24295 20.4902 3.01295L21.1602 0.462948C21.2602 0.082948 20.7802 -0.167052 20.5202 0.132948L16.8202 4.50295C16.6202 4.74295 16.7902 5.11295 17.1002 5.11295H19.2502C19.4902 5.11295 19.6702 5.34295 19.6102 5.57295L18.9402 8.12295C18.8402 8.50295 19.3202 8.75295 19.5802 8.45295L23.3002 4.08295C23.4902 3.84295 23.3202 3.47295 23.0002 3.47295Z"
      fill="#787F88"
    />
    <path
      d="M18.34 22.0029H5.66C3.64 22.0029 2 20.3629 2 18.3429V5.66294C2 3.64294 3.64 2.00294 5.66 2.00294H14C14.55 2.00294 15 2.45294 15 3.00294C15 3.55294 14.55 4.00294 14 4.00294H5.66C4.74 4.00294 4 4.74294 4 5.66294V18.3529C4 19.2629 4.74 20.0029 5.66 20.0029H18.34C19.25 20.0029 20 19.2629 20 18.3429V12.0029C20 11.4529 20.45 11.0029 21 11.0029C21.55 11.0029 22 11.4529 22 12.0029V18.3429C22 20.3629 20.36 22.0029 18.34 22.0029Z"
      fill="#787F88"
    />
    <path
      d="M10.7701 8.96295C10.2401 8.96295 9.81006 8.53295 9.81006 8.00295C9.81006 7.47295 10.2401 7.04295 10.7701 7.04295C11.3001 7.04295 11.7301 7.47295 11.7301 8.00295C11.7301 8.53295 11.3001 8.96295 10.7701 8.96295Z"
      fill="#787F88"
    />
    <path
      d="M7.73002 17.603C7.20002 17.603 6.77002 17.173 6.77002 16.643C6.77002 16.113 7.20002 15.683 7.73002 15.683C8.26002 15.683 8.69002 16.113 8.69002 16.643C8.69002 17.173 8.26002 17.603 7.73002 17.603Z"
      fill="#787F88"
    />
    <path
      d="M13.8101 17.603C13.2801 17.603 12.8501 17.173 12.8501 16.643C12.8501 16.113 13.2801 15.683 13.8101 15.683C14.3401 15.683 14.7701 16.113 14.7701 16.643C14.7701 17.173 14.3401 17.603 13.8101 17.603Z"
      fill="#787F88"
    />
    <path
      d="M13.77 14.4629C13.36 14.4629 13.02 14.1229 13.02 13.7129V13.1329H8.47998V13.7129C8.47998 14.1229 8.13998 14.4629 7.72998 14.4629C7.31998 14.4629 6.97998 14.1229 6.97998 13.7129V12.3829C6.97998 11.9729 7.31998 11.6329 7.72998 11.6329H13.77C14.18 11.6329 14.52 11.9729 14.52 12.3829V13.7129C14.52 14.1229 14.18 14.4629 13.77 14.4629Z"
      fill="#787F88"
    />
    <path
      d="M10.77 13.123C10.36 13.123 10.02 12.783 10.02 12.373V11.003C10.02 10.593 10.36 10.253 10.77 10.253C11.18 10.253 11.52 10.593 11.52 11.003V12.373C11.52 12.783 11.18 13.123 10.77 13.123Z"
      fill="#787F88"
    />
  </svg>
);
export default FlowAction;
